(function() { window.GUID_eddd2778_2d73_4918_85d2_4812f4d1e0ff = { getGuid: function() { return "eddd2778-2d73-4918-85d2-4812f4d1e0ff"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-events",
                        callback: (control, e) => {
                            if (!$("#stats-wall-v2").length) {
                                // Overridé sur StatsWallV2
                                control.$Container.offon("click.event-box", ".event-box__header", handleEventBoxClick);
                            }
                        }
                    });
                    CS.Controls.Accordion.Events.ContentLoaded({
                        selector: "body",
                        childSelector: ".accordion-events",
                        callback: function (control, e) {
                            GoogleAds.BindAds(true, control.$Content);
                        }
                    });
                    function handleEventBoxClick(e) {
                        const $target = $(e.target), $eventBox = $target.closest(".event-box:not(.no-redirect)"), url = $eventBox.data("url");
                        const controller = CS.CommonData.Current.Navigation.Controller;
                        if (controller == "personawall"
                            || controller == "divisionswall") {
                            const isInPopup = $target.closest(".popup.control-cs").length > 0;
                            if (isInPopup)
                                return;
                        }
                        if (url != null) {
                            CS.Nav.Go(url);
                        }
                    }
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=event-box.js.map
